import React from 'react';
import GenericExplanation from 'client/QuestionTypes/common/V2/GenericExplanation.react';

export const FreeResponseExplanation = (props) => {
  return <GenericExplanation {...props} hideResultIndicatorBar />;
};
